<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="ml-4 sm:ml-0">
        <LogoIcon />
      </div>
      <div class="h-12 mt-5 mb-5 mr-4 sm:mr-8">
        <LanguageSwitch />
      </div>
    </div>
    <div class="max-w-[460px] w-full text-center flex-grow px-4">
      <h2 class="mt-5 mt-10 mb-5 text-center">
        {{ $t('messages.sign_up.title') }}
      </h2>
      <div class="sm:flex justify-between">
        <div class="sm:w-1/2 sm:pr-2">
          <label
            for="first_name"
            class="b2 block text-left w-full mb-2 text-zyxel-gray-800"
          >{{
            $t('messages.text_input.first_name')
          }}<span class="ml-2 text-zyxel-red-700">*</span></label>
          <input
            id="first_name"
            v-model="first_name"
            :class="['text-input pt-4 pl-4 pb-4 text-left h-12 w-full', { 'error-input': errors.first_name }]"
            :aria-invalid="errors.first_name"
            @keyup.enter="handleSubmit"
          >
          <span
            v-if="errors.first_name"
            class="error-message mt-1 b2 block text-left w-full"
            role="alert"
            aria-live="assertive"
          >{{
            $t(errors_msg.first_name) }}</span>
        </div>
        <div class="mt-2 sm:w-1/2 sm:pl-2 sm:mt-0">
          <label
            for="last_name"
            class="b2 block text-left w-full mb-2 text-zyxel-gray-800"
          >{{
            $t('messages.text_input.last_name')
          }}<span class="ml-2 text-zyxel-red-700">*</span></label>
          <input
            id="last_name"
            v-model="last_name"
            :class="['text-input pt-4 pl-4 pb-4 text-left h-12 w-full', { 'error-input': errors.last_name }]"
            :aria-invalid="errors.last_name"
            @keyup.enter="handleSubmit"
          >
          <span
            v-if="errors.last_name"
            class="error-message mt-1 b2 block text-left w-full"
            role="alert"
            aria-live="assertive"
          >{{
            $t(errors_msg.last_name) }}</span>
        </div>
      </div>
      <label
        for="email"
        class="b2 block text-left w-full mt-2 mb-2 text-zyxel-gray-800"
      >{{ $t('messages.text_input.email')
      }}<span class="ml-2 text-zyxel-red-700">*</span></label>
      <input
        id="email"
        v-model="email"
        type="text"
        inputmode="email"
        :class="['text-input pt-4 pl-4 pb-4 text-left h-12 w-full', { 'error-input': errors.email }]"
        placeholder="name@example.com"
        :aria-invalid="errors.email"
        @keyup.enter="handleSubmit"
      >
      <span
        v-if="errors.email"
        class="error-message mt-1 b2 block text-left w-full"
        role="alert"
        aria-live="assertive"
      >{{
        $t(errors_msg.email) }}</span>
      <label
        for="country"
        class="b2 block text-left w-full mt-2 mb-2 text-zyxel-gray-800"
      >{{
        $t('messages.text_input.country_region')
      }}<span class="ml-2 text-zyxel-red-700">*</span></label>
      <CountrySelect
        v-model="country"
        :aria-invalid="errors.country"
      />
      <label
        for="contact"
        class="b2 block text-left w-full mt-2 mb-2 text-zyxel-gray-800"
      >{{ $t('messages.text_input.contact')
      }}</label>
      <input
        id="contact"
        v-model="contact"
        type="text"
        inputmode="email"
        :class="['text-input pt-4 pl-4 pb-4 text-left h-12 w-full', { 'error-input': errors.contact }]"
        placeholder="name@example.com"
        :aria-invalid="errors.contact"
        @keyup.enter="handleSubmit"
      >
      <span
        v-if="errors.contact"
        class="error-message mt-1 b2 block text-left w-full"
        role="alert"
        aria-live="assertive"
      >{{
        $t(errors_msg.contact) }}</span>
      <span class="b3 block text-left flex items-center"><img
        class="h-3 mr-1"
        src="@/assets/svg/icon_24px_info.svg"
        alt=""
        aria-hidden="true"
      >{{ $t('messages.text_input.contact_info') }}</span>
      <div class="mycheckbox mt-5">
        <div class="flex items-center cursor-pointer">
          <input
            id="marketing_subscription"
            v-model="marketingSubscription"
            type="checkbox"
            class="opacity-0 absolute h-8 w-8"
          >
          <div :class="[{ 'border-zyxel-green-500': marketingSubscription, 'border-gray-800': !marketingSubscription }, 'border-2 w-6 h-6 rounded-md']" />
          <label
            for="marketing_subscription"
            class="ml-2 text-left b1 text-zyxel-gray-800 cursor-pointer flex-1"
          >{{ $t('messages.text_input.marketing_subscription') }}</label>
        </div>
      </div>
      <button
        class="button-primary w-full mt-4 mb-3"
        @click="handleSubmit"
      >
        {{ $t('messages.button.sign_up')
        }}
      </button>
      <div class="flex">
        <img
          class="h-3 mt-1 mr-1"
          src="@/assets/svg/icon_24px_info.svg"
          alt=""
          aria-hidden="true"
        >
        <span class="b3 text-left">{{ $t('messages.button.sign_up_info') }}<a
          href="https://www.zyxel.com/global/en/terms-of-use"
          target="_blank"
          class="b3 text-zyxel-green-800 ml-1 mr-1"
          aria-label="Terms of Use"
        >
          {{ $t('messages.sign_up.link_terms_of_use') }} </a> &
          <a
            href="https://www.zyxel.com/global/en/privacy-policy"
            target="_blank"
            class="b3 text-zyxel-green-800 ml-1 mr-1"
            aria-label="Privacy Policy"
          >
            {{ $t('messages.sign_up.link_private_policy') }}.</a></span>
      </div>
      <div class="mt-4 mb-6">
        <span
          class="mr-4 b1 text-zyxel-gray-800"
          style="color: #575757"
        >{{
          $t('messages.common.hint_already_user')
        }}</span><router-link
          class="b1 text-zyxel-green-700"
          :to="{ name: 'SignIn' }"
        >
          {{
            $t('messages.common.link_sign_in') }}
        </router-link>
      </div>

      <div class="mb-6">
        <span
          class="mr-4 b1"
          style="color: #575757"
        >{{ $t('messages.common.hint_not_activated') }}</span><br>
        <router-link
          class="b1 text-zyxel-green-700"
          :to="{ name: 'SendActivation' }"
        >
          {{
            $t('messages.common.link_resent_activation') }}
        </router-link>
      </div>
    </div>
    <ZyxelFooter />
  </div>
</template>
<script setup>
/* global grecaptcha */
import { recaptchaSitekey } from '@/config';
import { logger } from '@/utils/logger';
const first_name = ref('');
const last_name = ref('');
const email = ref('');
const country = ref('');
const contact = ref('');
const marketingSubscription = ref(false);
const errors_msg = ref({
    first_name: false,
    last_name: false,
    email: false,
    country: false,
    contact: false
})
const errors = ref({
    first_name: false,
    last_name: false,
    email: false,
    country: false,
    contact: false
})
const { locale } = useI18n();
const isScriptLoaded = ref(false);

const loadScript = (src, callback) => {
    if (!document.head.querySelector(`script[src="${src}"]`)) {
        let script = document.createElement('script');
        script.onload = callback;
        script.src = src;
        script.setAttribute("async", "true");
        script.setAttribute("defer", "true");
        document.head.appendChild(script);
    } else {
        callback();
    }
}

if (!isScriptLoaded.value) {
    loadScript('https://www.google.com/recaptcha/enterprise.js?render=' + recaptchaSitekey, () => {
        isScriptLoaded.value = true;
    });
}

const fetchGeoIPData = async () => {
    try {
        const response = await axios.get(`${apiBaseUrl}/api/geoip`);
        country.value = response.data.iso_code;
    } catch (error) {
        logger.error('Error fetching GeoIP data:', error);
        country.value = "TW";
    }
}

const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}


const isDisposableEmail = async () => {
    try {
        const response = await axios.post(`${apiBaseUrl}/api/disposable_email/verify`, {
            email: email.value.trim()
        });
        if (response.status === 200) {
            if (response.data.success === false) {
                errors.value.email = true;
                errors_msg.value.email = "messages.error_msg.disposable_email";
                return false;
            } else {
                return true;
            }
        } else {
            errors.value.email = true;
            errors_msg.value.email = "messages.error_msg.disposable_email";
            return false;
        }
    } catch (error) {
        errors.value.email = true;
        errors_msg.value.email = "messages.error_msg.disposable_email";
        return false;
    }
}


const checkInputs = () => {
    let valid = true;
    errors.value.first_name = false;
    errors.value.last_name = false;
    errors.value.email = false;
    errors.value.contact = false;

    if (first_name.value.trim().length === 0) {
        errors.value.first_name = true;
        errors_msg.value.first_name = "messages.error_msg.field_empty";
        valid = false;
    } else if (first_name.value.trim().length > 80) {
        errors.value.first_name = true;
        errors_msg.value.first_name = "messages.error_msg.length_80";
        valid = false;
    }

    if (last_name.value.trim().length === 0) {
        errors.value.last_name = true;
        errors_msg.value.last_name = "messages.error_msg.field_empty";
        valid = false;
    } else if (last_name.value.trim().length > 80) {
        errors.value.last_name = true;
        errors_msg.value.last_name = "messages.error_msg.length_80";
        valid = false;
    }

    if (email.value.trim().length === 0) {
        errors.value.email = true;
        errors_msg.value.email = "messages.error_msg.field_empty";
        valid = false;
    } else if (email.value.trim().length > 250) {
        errors.value.email = true;
        errors_msg.value.email = "messages.error_msg.length_250";
        valid = false;
    } else if (!isValidEmail(email.value.trim())) {
        errors.value.email = true;
        errors_msg.value.email = "messages.error_msg.email_valid";
        valid = false;
    }

    if (contact.value.trim().length > 0) {
        if (contact.value.trim().length > 250) {
            errors.value.contact = true;
            errors_msg.value.contact = "messages.error_msg.length_250";
            valid = false;
        }
        if (!isValidEmail(contact.value.trim())) {
            errors.value.contact = true;
            errors_msg.value.contact = "messages.error_msg.email_valid";
            valid = false;
        }
    }

    return valid;
}

const handleSignUp = async () => {
    try {
        const appid = localStorage.getItem('appId');
        const urlWithQuery = `${apiBaseUrl}/api/users/register?_fdl_app_id=${encodeURIComponent(appid)}`;
        logger.log("locale = " + locale.value);
        const response = await axios.post(urlWithQuery, {
            first_name: first_name.value.trim(),
            last_name: last_name.value.trim(),
            email: email.value.trim(),
            country: country.value,
            contact: contact.value.trim(),
            subscribe_marketing_notification: marketingSubscription.value,
            locale: locale.value
        });

        logger.log('Success:', response);
        router.push({ name: 'WaitActivation', query: { to_email: email.value.trim() } });
    } catch (error) {
        logger.error('Error:', error);
        errors.value.email = true;
    }
}

const handleSubmit = async () => {
    if (!checkInputs()) {
        logger.error('Invalid inputs');
        return;
    }
    const isEmailValid = await isDisposableEmail();
    if (!isEmailValid) {
        logger.error('Email Invalid');
        return;
    }
    let action_event = 'signup';

    // 啟動 reCAPTCHA 並執行驗證
    grecaptcha.enterprise.ready(async () => {
        const token = await grecaptcha.enterprise.execute(recaptchaSitekey, { action: action_event });
        logger.log("recaptcha_verify_setting:" + recaptchaVerifyFlag);
        logger.log('reCAPTCHA token:', token);
        logger.log('reCAPTCHA action:', action_event);

        // 將驗證結果提交到後端伺服器
        axios.post(`${apiBaseUrl}/api/recaptcha/token`, {
            token: token,
            action: action_event
        }).then(response => {
            if (recaptchaVerifyFlag) {
                logger.log('Success:', response);
                const success = response.data.success;
                const score = response.data.score;
                const reason = response.data.reason;
                logger.log('score:', score);
                logger.log('reason:', reason);
                if (success && score > 0.5) {
                    handleSignUp(); // 驗證成功後的處理函式
                } else {
                    router.push({ name: 'RobotEndpoint' });
                }
            } else {
                handleSignUp(); // 驗證成功後的處理函式
            }
        })
            .catch(error => {
                logger.error('Error:', error);
            });
    });
};

onMounted(() => {
    fetchGeoIPData();
});
</script>
<script>
import { ref, onMounted } from 'vue';
import LogoIcon from '@/components/LogoIcon.vue';
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import ZyxelFooter from "@/components/ZyxelFooter.vue";
import axios from 'axios';
import { apiBaseUrl, recaptchaVerifyFlag } from '@/config.js';
import router from '@/router/index';
import CountrySelect from '@/components/CountrySelect.vue';
import { useI18n } from 'vue-i18n';


export default {
    name: 'SignUpPage',
    components: {
        LogoIcon,
        LanguageSwitch,
        ZyxelFooter,
        CountrySelect
    },
    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            country: '',
            contact: '',
            errors: {
                first_name: false,
                last_name: false,
                email: false,
                country: false,
                contact: false,
            },
            autocomplete: true,
            usei18n: false,
            isScriptLoaded: false
        };
    },
    methods: {
        handleSignUp() {
            if (this.checkInputs()) {
                logger.log("ok");
            }
        },
        checkInputs() {
            this.errors.first_name = !this.first_name;
            this.errors.last_name = !this.last_name;
            this.errors.email = !this.isValidEmail(this.email);
            this.errors.contact = this.contact && !this.isValidPhoneNumber(this.contact);
            this.errors.country = !this.country;

            return !(this.errors.first_name || this.errors.last_name || this.errors.email || this.errors.contact || this.errors.country);
        },
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }
    },
}
</script>